import React from 'react';
import { Route, IndexRoute } from 'react-router';
import employee from './screens/List/screens/Employee/router';
import department from './screens/List/screens/Department/router';
import underDepartment from './screens/List/screens/UnderDepartment/router';
export default (
  <Route
    path="peoplesearch"
  >
    <IndexRoute
      getComponent={(Location, callback) => {
        require.ensure([], (require) => {
          callback(null, require('./index'));
        });
      }}
    />
    {underDepartment}
    {department}
    {employee}
  </Route>
);



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/screens/Tube/screens/PeopleSearch/router.js
 **/